import { NgModule, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MindmapComponent } from './mindmap.component';
import { ToolbarService } from './services/toolbar.service';
import { ColorService } from './services/color.service';
import { MutualService } from './services/mutual.service';
import { CollapseService } from './services/collapse.service';
import { NodeService } from './services/node.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EdgehandlesService } from './services/edgehandles.service';
import { PanzoomService } from './services/panzoom.service';
import { NgxFontAwesomeModule } from 'ngx-font-awesome';

@NgModule({
  declarations: [MindmapComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot(),
    NgxFontAwesomeModule
  ],
  providers: [
    ToolbarService,
    ColorService,
    MutualService,
    CollapseService,
    NodeService,
    EdgehandlesService,
    PanzoomService
  ],
  bootstrap: [MindmapComponent],
  exports: [MindmapComponent]
})
export class MindmapModule {

 }


